import { useEffect, useLayoutEffect, useRef, useState, useSyncExternalStore } from 'react'
import { registerBackHandler } from '@/lib/navigation/back-handlers'
import { ActionSheetDrawer } from './ActionSheetDrawer.tsx'
import {
  getActionSheetSnapshot,
  handleActionSheetAnimationEnd,
  handleActionSheetOpenChange,
  subscribeToActionSheet,
} from './action-sheet-store.ts'

function getEmptyActionSheetSnapshot() {
  return { open: false, options: null }
}

export function ActionSheetViewport() {
  const closeRef = useRef<HTMLButtonElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [container, setContainer] = useState<HTMLElement | null>(null)
  const { open, options } = useSyncExternalStore(
    subscribeToActionSheet,
    getActionSheetSnapshot,
    getEmptyActionSheetSnapshot,
  )

  useLayoutEffect(() => {
    const host = containerRef.current?.closest('.app-container')
    if (host instanceof HTMLElement) {
      setContainer(host)
    }
  }, [])

  useEffect(() => {
    if (!open) {
      return
    }
    return registerBackHandler(() => {
      if (getActionSheetSnapshot().options?.dismissible === false) {
        return true
      }
      closeRef.current?.click()
      return true
    })
  }, [open])

  const drawerOpen = open && container != null

  return (
    <div ref={containerRef} aria-hidden="true">
      <ActionSheetDrawer
        open={drawerOpen}
        options={options}
        container={container}
        closeRef={closeRef}
        onOpenChange={handleActionSheetOpenChange}
        onAnimationEnd={handleActionSheetAnimationEnd}
      />
    </div>
  )
}
